import WebLayout from './SeparatorLayout.web';
import MobileLayout from './SeparatorLayout.mobile';
import { isReactNative }   from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
